function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFidelityInvestments = function SvgFidelityInvestments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.20248 41.194817",
    id: "Layer_1"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-365.24977,-524.73747)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 385.04475,563.08065 c 10.0775,0 18.2425,-8.1675 18.2425,-18.245 0,-10.07375 -8.165,-18.24125 -18.2425,-18.24125 -10.075,0 -18.2425,8.1675 -18.2425,18.24125 0,10.0775 8.1675,18.245 18.2425,18.245",
    id: "path38495",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 382.24075,547.87715 6.71375,0 1.96125,1.27125 -8.97125,0 -4.02625,12.44625 c -4.44875,-1.72375 -8.56625,-5.72125 -10.2925,-10.21375 -1.84125,-4.3525 -1.84125,-9.82125 0.04,-14.19125 1.76375,-4.495 6,-8.5525 10.50875,-10.22 3.5475,-1.46875 8.295,-1.62375 12.0575,-0.46875 4.3175,1.23625 8.39375,4.33125 10.765,8.37125 2.65,4.43 3.39375,10.05875 1.78375,15.11625 -1.0175,3.355 -3.11625,6.5675 -6.00125,8.86625 l -4.95625,-8.2575 6.89875,3.84625 c 0.0387,0 0.0588,-0.0425 0.0387,-0.0825 l -9.03625,-7.80125 11.68625,1.78375 c 0.04,0 0.0562,-0.0187 0.0562,-0.0387 l -0.075,-0.0588 -11.02,-3.86375 11.45125,-2.76625 c 0.0388,0 0.0388,-0.0362 0.0188,-0.0562 l -11.74625,0.765 9.1975,-6.96375 c 0.02,-0.0375 -0.06,-0.0562 -0.08,-0.0175 l -10.33125,5.23875 5.70375,-10.0625 c 0,-0.0162 0,-0.0587 -0.0362,-0.0375 l -7.4525,8.745 1.43,-11.49 c 0,-0.0213 -0.04,-0.04 -0.0788,-0.0213 l -3.4275,11.1575 -3.00125,-11.49125 c -0.02,-0.0188 -0.0612,-0.04 -0.08,0 l 0.82625,11.92 -7.0775,-9.21125 c -0.0238,-0.0213 -0.0412,0 -0.0612,0.0187 l 5.35375,10.19375 -10.12,-5.53 c -0.0188,0 -0.0575,0.0213 -0.0575,0.0387 l 8.99875,7.39125 -11.4875,-1.2125 c -0.0412,0.0213 -0.0412,0.0562 0,0.075 l 11.1375,3.25875 -11.07875,3.255 c -0.0213,0.0163 -0.0213,0.0575 0,0.075 l 11.42875,-1.33125 -8.98,7.6275 c -0.0188,0 -0.0387,0.0387 0,0.0612 l 0.12,-0.04 7.1925,-3.76625 1.68875,-2.685 1.91875,0 -1.33125,-0.94125 4.45,-7.13875 -2.625,8.4325 0.005,0.004",
    id: "path38499",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 415.377,557.27515 -8.965,0 7.17875,-25.62625 18.3775,0 -1.75125,6.08125 -9.37875,0 -1.2025,4.3625 9.37875,0 -1.58125,5.5975 -9.3775,0 -2.67875,9.585 z",
    id: "path38503",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436.12337,557.27515 -8.86125,0 5.255,-18.72125 8.86125,0 -5.255,18.72125 z m 5.73625,-20.5075 -8.86125,0 1.4425,-5.11875 8.86125,0 -1.4425,5.11875 z",
    id: "path38507",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 459.114,557.27515 -8.69,0 0.6175,-2.095 c -1.7525,1.47625 -3.5375,2.54125 -6.38875,2.54125 -2.88625,0 -4.705,-1.375 -4.705,-4.295 0,-3.2275 1.27125,-8.0375 3.16,-11.40375 1.37375,-2.5075 3.84625,-3.8125 6.76625,-3.8125 2.50625,0 4.36125,1.1 5.08375,2.4725 l 2.47375,-9.03375 8.86125,0 -7.17875,25.62625 z m -6.66375,-13.1575 c -0.79125,0 -1.58,0.2425 -2.02625,1.34 -0.65375,1.58 -1.2375,3.12625 -1.2375,4.67125 0,0.7225 0.51625,1.34 1.37375,1.34 0.6875,0 1.13375,-0.20625 1.51125,-0.445 l 1.7875,-6.15 c -0.31,-0.4475 -0.86,-0.75625 -1.40875,-0.75625",
    id: "path38511",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 484.137,549.09903 -12.2275,0 c -0.2425,0.995 -0.48125,1.68375 -0.48125,2.4725 0,0.37875 0.0688,1.34 1.305,1.34 1.23625,0 1.78625,-0.48125 2.30125,-2.30125 l 8.69,0 c -1.09875,5.325 -7.41875,7.14375 -11.3,7.14375 -5.25625,0 -9.34375,-0.755 -9.34375,-5.80375 0,-2.7825 1.4075,-7.38625 3.26375,-9.82375 2.2325,-2.92 6.11375,-4.0175 9.6875,-4.0175 5.495,0 9.06625,1.1325 9.06625,5.8025 0,1.135 -0.48,3.64125 -0.96125,5.1875 m -8.8625,-6.285 c -1.09875,0 -1.85375,0.755 -2.335,2.64375 l 3.64,0 c 0.10375,-0.3775 0.24125,-0.96125 0.24125,-1.305 0,-1.03 -0.61875,-1.33875 -1.54625,-1.33875",
    id: "path38515",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 493.0435,557.27515 -8.8625,0 7.17875,-25.62625 8.8625,0 -7.17875,25.62625 z",
    id: "path38519",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 504.75237,557.27515 -8.86375,0 5.25625,-18.72125 8.8625,0 -5.255,18.72125 z m 5.735,-20.5075 -8.86125,0 1.4425,-5.11875 8.8625,0 -1.44375,5.11875 z",
    id: "path38523",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 526.42025,538.55365 0.77125,4.225 -6.7825,0 -1.9925,7.11125 c -0.17125,0.54875 -0.31,1.235 -0.31,1.6825 0,0.82375 0.345,1.1 1.54625,1.1 l 1.89,0 -1.30625,4.6025 -7.9,0 c -2.61125,0 -3.6075,-1.27125 -3.6075,-3.19625 0,-0.7875 0.10375,-1.64875 0.37875,-2.61 l 4.80875,-17.07125 8.8625,0 -1.16875,4.15625 4.81,0",
    id: "path38527",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 406.23075,560.1534 2.20875,-0.003 -1.4075,4.60875 -2.2025,10e-4 1.40125,-4.6075 z",
    id: "path38531",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 413.94062,560.15753 3.23125,-0.002 0.82875,3.07375 0.0225,0 0.935,-3.075 1.9175,-0.002 -1.4175,4.59875 -3.09125,0.0113 -0.89625,-3.28375 -0.015,0 -0.98,3.2775 -1.91875,10e-4 1.38375,-4.59875 z",
    id: "path38535",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 425.06387,560.15953 2.4325,-10e-4 0.425,2.89625 2.225,-2.89875 2.25125,-0.003 -3.71125,4.6 -2.7,0.002 -0.9225,-4.59625 z",
    id: "path38539",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 436.63275,560.1609 5.025,-0.004 -0.28375,0.93125 -2.88875,0.003 -0.28,0.945 2.70875,-10e-4 -0.27125,0.8875 -2.7075,10e-4 -0.28,0.9125 2.91875,-0.003 -0.29375,0.9325 -5.0525,0.004 1.405,-4.60875 z",
    id: "path38543",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 458.21487,561.28278 -1.72125,10e-4 0.34125,-1.1175 5.6475,-0.005 -0.34,1.1175 -1.72,0.002 -1.055,3.4675 -2.20625,0.003 1.05375,-3.46875 z",
    id: "path38547",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 467.05263,560.15478 3.34625,-0.002 0.1625,3.075 0.0138,0 1.995,-3.07625 3.3625,-0.004 -1.39625,4.60875 -2.0475,0.002 1.05,-3.47125 -0.0163,0 -2.48625,3.4725 -2.13375,0.003 -0.30125,-3.47125 -0.0225,0 -1.04875,3.46125 -1.87375,10e-4 1.39625,-4.59875 z",
    id: "path38551",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 489.9945,560.15753 3.22875,-0.002 0.83125,3.07375 0.0213,0 0.935,-3.07625 1.91625,-10e-4 -1.4025,4.61 -3.13125,-0.009 -0.87,-3.275 -0.0138,0 -1.00375,3.27625 -1.9175,0.002 1.40625,-4.59875 z",
    id: "path38555",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 502.22375,561.27602 -1.7225,10e-4 0.34125,-1.11875 5.64875,-0.004 -0.34,1.1175 -1.72125,0.002 -1.05375,3.47875 -2.20875,0.003 1.05625,-3.48 z",
    id: "path38559",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 448.42825,561.55328 c -0.0487,-0.0512 -0.0512,-0.13875 -0.0312,-0.21 0.0725,-0.23375 0.365,-0.3875 0.83125,-0.3875 0.275,-10e-4 0.6975,0.03 0.81875,0.12625 0.12875,0.0937 0.17,0.235 0.125,0.37375 l 1.95625,0 c 0.23,-0.8225 -0.2875,-1.3525 -2.49625,-1.35125 -2.09875,0.003 -3.28875,0.4525 -3.595,1.45625 -0.0787,0.2625 -0.0888,0.585 0.1275,0.8025 0.54125,0.5375 2.98125,0.75125 3.1875,1.04125 0.0413,0.0588 0.0575,0.12875 0.0325,0.21125 -0.1125,0.37 -0.63625,0.465 -1.09375,0.465 -0.29125,0 -0.66875,-0.0625 -0.7775,-0.1825 -0.1025,-0.12125 -0.1025,-0.30625 -0.0438,-0.425 l -2.0475,0.004 c -0.20625,0.71375 -0.29375,1.45625 2.55375,1.455 2.3875,-0.003 3.48125,-0.5875 3.75625,-1.49625 0.13625,-0.445 10e-4,-0.69125 -0.15375,-0.85 -0.53,-0.54625 -2.89375,-0.7475 -3.15,-1.0325",
    id: "path38565",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 480.42862,560.16215 5.025,-0.004 -0.2825,0.93125 -2.89,0.002 -0.28,0.945 2.70875,-10e-4 -0.27125,0.8875 -2.7075,10e-4 -0.28,0.91375 2.91875,-0.002 -0.29375,0.93125 -5.0525,0.005 1.405,-4.61 z",
    id: "path38569",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 538.3835,538.55365 -4.80875,10.37375 0.1375,-10.37375 -8.965,0 1.7175,18.72125 c -0.22,1.09625 -0.5825,1.71375 -1.27,2.01875 -0.7525,0.335 -2.45375,0.27625 -3.0525,0.2425 l -0.10875,0.006 -1.4125,5.08625 6.04875,0.006 c 3.5725,0 5.325,-1.79625 7.86625,-5.78 l 12.91625,-20.30125 -9.06875,0",
    id: "path38573",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 512.22137,561.54253 c -0.0487,-0.0525 -0.05,-0.14 -0.0312,-0.21 0.0738,-0.235 0.365,-0.38875 0.83125,-0.38875 0.275,0 0.6975,0.0312 0.81875,0.1275 0.13,0.0925 0.17125,0.235 0.125,0.37375 l 1.95625,0 c 0.23125,-0.8225 -0.2875,-1.35375 -2.49625,-1.35125 -2.09875,0.002 -3.28875,0.4525 -3.59375,1.45625 -0.08,0.26125 -0.09,0.585 0.12625,0.80125 0.54125,0.53875 2.98125,0.7525 3.1875,1.0425 0.0425,0.0575 0.0575,0.12875 0.0325,0.21125 -0.11125,0.37 -0.63625,0.46375 -1.0925,0.465 -0.2925,0 -0.67,-0.0625 -0.77875,-0.18375 -0.10125,-0.12125 -0.10125,-0.305 -0.0437,-0.42375 l -2.0475,0.002 c -0.20625,0.715 -0.29375,1.4575 2.55375,1.45625 2.3875,-0.004 3.48125,-0.5875 3.7575,-1.4975 0.135,-0.445 10e-4,-0.69125 -0.155,-0.84875 -0.53,-0.54625 -2.89375,-0.7475 -3.15,-1.0325",
    id: "path38577",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 539.7805,556.93078 c -0.8875,0 -1.605,-0.71875 -1.605,-1.605 0,-0.88625 0.7175,-1.605 1.605,-1.605 0.88625,0 1.605,0.71875 1.605,1.605 0,0.88625 -0.71875,1.605 -1.605,1.605 m 0,-3.55625 c -1.07625,0 -1.95125,0.87625 -1.95125,1.95125 0,1.075 0.875,1.95125 1.95125,1.95125 1.07375,0 1.95,-0.87625 1.95,-1.95125 0,-1.075 -0.87625,-1.95125 -1.95,-1.95125",
    id: "path38645",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 539.44563,555.19128 0,-0.56375 0.2675,0 c 0.22875,-0.005 0.47875,0.01 0.47875,0.28 0,0.27 -0.25,0.28375 -0.47875,0.28375 l -0.2675,0 z m 1.11625,-0.26875 c 0,-0.38875 -0.22625,-0.6075 -0.71125,-0.6075 l -0.7575,0 0,2.0125 0.3525,0 0,-0.82375 0.2675,0 0.50375,0.82375 0.3875,0 -0.52625,-0.8525 c 0.27625,-0.0337 0.48375,-0.20375 0.48375,-0.5525",
    id: "path38649",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 538.36975,538.59928 -4.79375,10.33875 0.1375,-10.33875 -8.93375,0 1.71125,18.65625 c -0.21875,1.0925 -0.58,1.7075 -1.265,2.0125 -0.75,0.3325 -2.445,0.27375 -3.0425,0.24 l -0.1075,0.006 -1.40875,5.07 6.0275,0.005 c 3.56125,0 5.3075,-1.78875 7.84,-5.75875 l 12.87125,-20.23125 -9.03625,0 z",
    id: "path38653",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })));
};
export default SvgFidelityInvestments;